import { useState, useEffect } from "react";
import { useApolloClient } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";
import { ourToast as toast } from "../../../utils";

const ALL_DIRECTIONS_QUERY = gql`
  query ALL_DIRECTIONS_QUERY($where: DirectionWhereInput) {
    Directions(where: $where) {
      RecId
      LoadedTravelTime
      EmptyTravelTime
    }
  }
`;

export const useTripLegZeroDirections = firstLeg => {
  const client = useApolloClient();
  const [legZero, setLegZero] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: DirectionData } = await client.query({
          query: ALL_DIRECTIONS_QUERY,
          variables: {
            where: {
              OriginLocationRecIdRef: firstLeg.Route.StartLocation.RecId,
              DestinationLocationRecIdRef: firstLeg.Route.PickupLocation.RecId,
              Priority: 1
            }
          }
        });
        if (
          DirectionData &&
          DirectionData.Directions &&
          DirectionData.Directions.length
        ) {
          const { LoadedTravelTime } = DirectionData.Directions[0];

          const obj = {
            RecId: firstLeg.RecId,
            OrderNumber: firstLeg.OrderNumber,
            Trip: firstLeg.Trip,
            Leg: 0,
            PickupDate: moment(firstLeg.PickupDate).subtract(
              LoadedTravelTime,
              "hours"
            ),
            Route: {
              LoadTime: "",
              TravelTime: LoadedTravelTime,
              StartLocation: firstLeg.Route.StartLocation,
              PickupLocation: firstLeg.Route.PickupLocation
            },
            StartLocation: firstLeg.Route.StartLocation,
            EndLocation: firstLeg.Route.PickupLocation,
            ArrivalDate: firstLeg.PickupDate
          };
          setLegZero([obj]);
        }
      } catch (err) {
        toast.error("Error getting Leg Zero Direction.");
      }
    };
    if (firstLeg) {
      fetchData();
    }
  }, [client, firstLeg]);
  return {
    legZero
  };
};

export const useTripLastLegDirections = (lastLeg, legNumber = 1) => {
  const client = useApolloClient();
  const [leg, setLeg] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: DirectionData } = await client.query({
          query: ALL_DIRECTIONS_QUERY,
          variables: {
            where: {
              OriginLocationRecIdRef: lastLeg.Route.DeliveryLocation.RecId,
              DestinationLocationRecIdRef: lastLeg.Route.EndingLocation.RecId,
              Priority: 1
            }
          }
        });

        const PickupDate = moment(lastLeg.ArrivalDate).add(
          lastLeg.Route.UnloadTime,
          "hours"
        );
        const obj = {
          RecId: lastLeg.RecId,
          OrderNumber: lastLeg.OrderNumber,
          Trip: lastLeg.Trip,
          // Leg: legNumber + 1,
          Leg: 99,
          PickupDate,

          Route: {
            LoadTime: "",

            DeliveryLocation: lastLeg.Route.DeliveryLocation,
            EndingLocation: lastLeg.Route.EndingLocation
          },
          StartLocation: lastLeg.Route.DeliveryLocation,
          EndLocation: lastLeg.Route.EndingLocation
        };
        if (
          DirectionData &&
          DirectionData.Directions &&
          DirectionData.Directions.length
        ) {
          const { EmptyTravelTime } = DirectionData.Directions[0];
          obj.ArrivalDate = moment(PickupDate).add(EmptyTravelTime, "hours");
          obj.Route.TravelTime = EmptyTravelTime;
        } else {
          obj.ArrivalDate = moment(PickupDate).add(
            lastLeg.Route.TravelTime,
            "hours"
          );

          obj.Route.TravelTime = lastLeg.Route.TravelTime;
        }
        setLeg([obj]);
      } catch (err) {
        toast.error("Error getting Last Leg Direction.");
      }
    };
    if (lastLeg) {
      fetchData();
    }
  }, [client, lastLeg, legNumber]);
  return {
    leg
  };
};

export const useTripLegDirections = legs => {
  const client = useApolloClient();
  const [linkedLegs, setLinkedLegs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const legsWithDirections = await Promise.all(
          legs.map(async (leg, i) => {
            const updatedLeg = { ...leg };
            const nextLeg = legs[i + 1];

            if (nextLeg) {
              const { data: DirectionData } = await client.query({
                query: ALL_DIRECTIONS_QUERY,
                variables: {
                  where: {
                    OriginLocationRecIdRef: leg.Route.DeliveryLocation.RecId,
                    DestinationLocationRecIdRef:
                      nextLeg.Route.PickupLocation.RecId,
                    Priority: 1
                  }
                }
              });
              if (
                DirectionData &&
                DirectionData.Directions &&
                DirectionData.Directions[0]
              ) {
                // const { EmptyTravelTime } = DirectionData.Directions[0];
                updatedLeg.TravelTime = leg.Route.TravelTime || 0;
              } else {
                updatedLeg.TravelTime = 0;
              }
            } else {
              updatedLeg.TravelTime = 0;
            }
            updatedLeg.StartLocation = leg.Route.PickupLocation;
            updatedLeg.EndLocation = leg.Route.DeliveryLocation;
            updatedLeg.showNextAvailable = true;
            return updatedLeg;
          })
        );
        setLinkedLegs(legsWithDirections);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        toast.error("Error getting Directions.");
      }
    };
    fetchData();
  }, [client, legs]);
  return {
    linkedLegs,
    loading
  };
};
